<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card grid-list-md>
      <ModelTitle title="Assign Department" @close="close()" />
      <v-card-text>
        <v-row v-if="Student">
          <v-col cols="12" sm="12">
            <div>
              Student:
              <span class="font-weight-bold text-capitalize">{{
                Student.fullName
              }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="12">
            <v-autocomplete dense autofocus hide-details :items="Classes" clearable item-text="name"
              v-model="selectedClass" return-object label="Select Department" outlined><template slot="item"
                slot-scope="{ item }">
                <span>{{ item.name }}</span>
                <v-spacer></v-spacer>
                <v-chip color="grey lighten-3">
                  <v-avatar left class="grey lighten-2">
                    <v-icon small>mdi-account-school-outline</v-icon>
                  </v-avatar>
                  <span>{{ item.studentCount }}</span>
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-if="selectedClass">
        <v-row align="center">
          <v-col cols="12" sm="12" md="6" offset-md="6">
            <v-text-field outlined dense type="number" hide-details @focus="$event.target.select()" class="right-input"
              v-model="fee" label="Fee"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" offset-md="6">
            <v-text-field outlined dense hide-details type="number" @focus="$event.target.select()" class="right-input"
              v-model="discount" label="Discount"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" offset-md="6">
            <v-text-field outlined dense hide-details @focus="$event.target.select()" class="right-input" type="number"
              v-model="charity" label="Charity"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" offset-md="6">
            <v-text-field outlined dense hide-details readonly @focus="$event.target.select()" class="right-input"
              type="number" v-model="parentPay" label="Parent Pay"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-if="selectedClass">
        <div>
          {{ Student.firstName }} fee will be {{ balancePayment | currency }} a
          month. And {{ charity | currency }} will be collected by sponsor / donation.
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="green lighten-1" :loading="loading" dark @click="submit()">save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import classesService from "@/modules/Classes/service.js";
// import studentService from "@/modules/Student/service.js";

export default {
  props: {
    editDialog: {
      default: false,
    },
    Student: {
      type: Object,
    },
  },
  name: "Assign-Class-to-student",
  data() {
    return {
      Classes: [],
      selectedClass: null,
      loading: false,
      dialog: false,
      fee: 0,
      discount: 0,
      charity: 0,
      sponsor: 0,
      parentPay: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    balancePayment() {
      return this.fee - this.discount - this.charity;
    },
  },
  watch: {
    editDialog(val) {
      this.Teacher = this.editTeacher;
      this.dialog = val;
    },
    selectedClass(val) {
      console.log("val in selected ", val);
      if (val) {
        this.fee = val.defaultFee;
        this.parentPay = val.defaultFee;
      }
    },
    discount(val) {
      this.parentPay = this.fee - val - this.charity;
    },
    parentPay(val) {
      this.sponsor = this.fee - this.discount - val;
    },
    charity(val) {
      this.parentPay = this.fee - this.discount - val
    },
    fee(val) {
      this.parentPay = val - this.discount - this.charity;
    },
    dialog(val) {
      if (val) {
        this.getClasses();
      }
    },
  },
  methods: {
    deleteRow(row) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          if (row.StudentTeacher) {
            classesService
              .removeStudent(row.StudentTeacher.id)
              .then((response) => {
                if (response.data) {
                  const studentId = (element) => element.id === row.id;

                  let i = this.StudentList.findIndex(studentId);
                  this.StudentList.splice(i, 1);
                  this.$swal(
                    "Remove!",
                    "Student has been remove from this teacher.",
                    "success"
                  );
                  // this.getList();
                }
              });
          }
        }
      });
    },
    async submit() {
      let obj = {
        ClassId: this.selectedClass.id,
        StudentId: this.Student.id,
        fee: this.fee,
        discount: this.discount,
        sponsor: this.sponsor,
        parentPay: this.parentPay,
        charity: this.charity,
      };
      classesService
        .assignStudent(obj)
        .then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Class was assist student",
            });
          this.empty();
          this.$emit("submit");
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });

      this.selectedStudent = null;
    },
    getClasses() {
      return classesService.getAll().then((response) => {
        this.Classes = response.data;
        console.log("response Teacher", this.Classes);

        return response;
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.selectedClass = null;
      this.fee = 0;
      this.discount = 0;
      this.sponsor = 0;
      this.parentPay = 0;
      this.charity = 0;
    },
  },
};
</script>

<style scoped></style>
